/* eslint-disable no-redeclare */
import { z } from 'zod';

export const Integer = z.number().int();

export type Integer = z.infer<typeof Integer>;

export const PositiveInteger = Integer.positive();

export type PositiveInteger = z.infer<typeof PositiveInteger>;
